import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumb, MenuAccount, WideCardFee } from '../../components/Main'
import { InteractorFeeSearch, InteractorCsvFee } from '../../interactors/Main'
import { useSelector } from 'react-redux'
import { defaultValueDownloadCSV, maxLimitExport } from '../../constant/global/validation'

const Fee = () => {
  const { t } = useTranslation()
  const queryParams = new URLSearchParams(window.location.search)
  const { account } = useSelector((state) => state.account)
  const { feeSearch } = InteractorFeeSearch()
  const { csvFee } = InteractorCsvFee()
  const [loading, setLoading] = useState(true)
  const [loadingCSV, setLoadingCSV] = useState(false)
  const [download, setDownload] = useState(defaultValueDownloadCSV)
  const [datacard, setDatacard] = useState([])
  const [payload, setPayload] = useState({
    page: 1,
    limit: 5,
    keywords: {
      text_search: queryParams.get('ref') ?? '',
      paid_status: '',
      account_uid: account.uid,
      store_uid: '',
    },
  })

  const handleResponse = useCallback((data) => {
    setDatacard(data)
    // csvFee(data.items, setDownload)
  }, [])

  useEffect(() => {
    if (loading) {
      feeSearch(payload, handleResponse, setLoading)
    }
  }, [handleResponse, loading, payload, feeSearch])

  const handleResponseCSV = useCallback(
    (data) => {
      csvFee(data?.items, setDownload)
    },
    [csvFee],
  )

  const handleFilter = (row) => {
    setPayload(row)
    setDatacard([])
    setLoading(true)
  }

  const getDataFee = () => {
    let payloadCsv = { ...payload }
    payloadCsv.limit = maxLimitExport
    setLoadingCSV(true)
    feeSearch(payloadCsv, handleResponseCSV, setLoadingCSV)
  }

  return (
    <>
      <Breadcrumb title={t('menu.fee')} className="mb-4" />
      <div className="container">
        <div className="row mb-8">
          <MenuAccount />
          <div className="col-xl-9 col-wd-9gdot5">
            <div className="flex-center-between mt-2">
              <h3 className="font-size-20 font-size-20-lg font-weight-bold mb-0">
                {t('menu.fee')}
              </h3>
            </div>
            <hr />
            <WideCardFee
              loading={loading}
              datacard={datacard}
              payload={payload}
              handleFilter={handleFilter}
              download={download}
              setDownload={setDownload}
              getDataFee={getDataFee}
              loadingCSV={loadingCSV}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Fee
